<div class="listing-sort-icons">
  <ng-container *ngIf="isTablet === false">
    <button [class.active]="viewMode === 'grid'" (click)="changeViewMode('grid')">
      <i class="icon-grid"></i>
    </button>
    <button [class.active]="viewMode === 'list'" (click)="changeViewMode('list')">
      <i class="icon-list"></i>
    </button>
  </ng-container>
</div>

<div *ngFor="let accessoryGroup of articleAccessory?.accessories" class="article-accessory-group">
  <div class="headline-third margin--bottom-l bold">{{ accessoryGroup.key }}</div>
  <div class="flex listing-items flex--wrap">
    <div
      class="grid__item listing-item"
      [ngClass]="{
        'one-third palm--one-whole small-desk--one-half': viewMode === 'grid',
        'one-whole': viewMode === 'list'
      }"
      *ngFor="let accessory of accessoryGroup.value"
    >
      <app-article-item
        class="card-product card-product--no-mobile-config"
        [viewMode]="viewMode"
        (alternativeArticleSelected)="selectAlternativeArticle($event)"
        [article]="$any(accessory.oArticle)"
      >
      </app-article-item>
    </div>
  </div>
  <hr />
</div>
